import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fiElementFocused]',
    standalone: false,
})
export class FiElementFocusedDirective {
    constructor(
        private elementRef: ElementRef,
        public renderer: Renderer2,
    ) {}

    @HostListener('focus', ['$event']) onFocus() {
        this.renderer.addClass(this.elementRef.nativeElement, 'selected');
    }

    @HostListener('blur', ['$event']) onblur() {
        this.renderer.removeClass(this.elementRef.nativeElement, 'selected');
    }
}
